// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2dHmy","footer":"ModalInfo_footer__3OjRO"};